(() => {
  const ROOT_SELECTOR = '.music-product';
  const PRODUCT_TRIGGER_SELECTOR = '[data-product-url]';

  function openProductUrl(url) {
    if (!url) return;
    window.open(url, '_blank', 'noopener');
  }

  function handleProductActivation(target) {
    const trigger = target.closest(PRODUCT_TRIGGER_SELECTOR);
    if (!trigger) return false;

    openProductUrl(trigger.dataset.productUrl);
    return true;
  }

  function initMusicProduct(sectionRoot) {
    if (!sectionRoot || sectionRoot.dataset.musicProductBound === 'true') return;

    sectionRoot.dataset.musicProductBound = 'true';

    sectionRoot.addEventListener('click', (event) => {
      handleProductActivation(event.target);
    });

    sectionRoot.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      if (!handleProductActivation(event.target)) return;

      event.preventDefault();
    });
  }

  function initAllMusicProductSections(container = document) {
    container.querySelectorAll(ROOT_SELECTOR).forEach(initMusicProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllMusicProductSections());
  } else {
    initAllMusicProductSections();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllMusicProductSections(event.target);
  });
})();
